<div class="viewport-1" [style.background-image]="'url(' + taskBackgroundImage + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="totalTaskPoints"></task-bar>

  <div class="task-screen-element find-the-picture-container"
    [style.background-image]="' ' + taskContainerColor + ' '"
    [class]="(animationComplete) ? 'taskShow' : 'taskHide'">
    <button class="replayVideo-no-timerbar" (click)="replayVideo()" [disabled]="disableVideo()"></button>
    <div class="word-to">
      <div class="word font-42">
        {{targetWord}}
      </div>
    </div>
    <div class="full-response-row">
      @if (!unmaskedTask) {
        <button [class]="{'next-button-grayed' : disableNextButton, 'next-button' : !disableNextButton, 'toggle-next-on' : toggleNextButton, 'next-button-hidden': hideNextButton}"
          [disabled]="disableNextButton" (click)="displayTrial()">
        </button>
      }
    </div>
    @if (!hideResponses) {
      <div class="full-response-row-picture">
        @for (response of responseOptions; track response.text) {
          <div class="picture-button-div">
            <button [class]="(disableResponseButtons) ? 'picture-response-block-grayed' : 'picture-response-block'"
              (click)="submitAnswer($index)"
              [style]="{'border-color':' ' + highlightColor + ' ', 'background-image':'url(' + response.imageUrl + ')' }"
              [disabled]="disableResponseButtons">
            </button>
          </div>
        }
      </div>
    }
  </div>
  <trial-counter [showCorrectIncorrect]="false" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTrialData()"></save-data-dialog>
</div>
